var redefine = require('./_redefine');
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.11@core-js/modules/_redefine-all.js
// module id = 50
// module chunks = 0